import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["panel"]
  static values = { panelId: String }

  toggle() {
    this.panelTarget.classList.toggle("hidden")
  }

  toggleRemote() {
    const panel = document.getElementById(this.panelIdValue)
    if (panel) panel.classList.toggle("hidden")
  }
}
